<script setup lang="ts">
/** 2–4 mutually exclusive short options in one 28px row. The active one carries the card surface. */
defineProps<{ modelValue: string; options: { value: string; label: string }[]; label?: string }>()
const emit = defineEmits<{ 'update:modelValue': [v: string] }>()
</script>

<template>
  <div class="flex flex-col gap-1.5">
    <span v-if="label" class="text-xs text-muted-foreground">{{ label }}</span>
    <div role="group" :aria-label="label" class="flex min-h-[var(--control-height)] gap-0.5 rounded-[var(--radius-control)] border border-border bg-secondary p-0.5">
      <button
v-for="o in options" :key="o.value" type="button"
        class="min-w-0 flex-1 rounded-[var(--radius-compact)] px-2 py-0.5 text-xs focus-visible:outline-2 focus-visible:outline-ring"
        :class="modelValue === o.value ? 'bg-card text-foreground' : 'text-muted-foreground hover:text-foreground'"
        :aria-pressed="modelValue === o.value" @click="emit('update:modelValue', o.value)">{{ o.label }}</button>
    </div>
  </div>
</template>
